import { axiosInstance } from "../../../utils";

const actions = {
  CREATE_OR_UPDATE_PROMOTION_REQUESTED: "CREATE_OR_UPDATE_PROMOTION_REQUESTED",
  CREATE_OR_UPDATE_PROMOTION_SUCCEEDED: "CREATE_OR_UPDATE_PROMOTION_SUCCEEDED",
  CREATE_OR_UPDATE_PROMOTION_FAILED: "CREATE_OR_UPDATE_PROMOTION_FAILED",

  addOrUpdatePromotion: (data = undefined) => {
    return {
      type: actions.CREATE_OR_UPDATE_PROMOTION_REQUESTED,
      payload: data,
    };
  },

  createOrUpdatePromotion: async (data = undefined) => {
    let url = `offers/create`;
    let bodyFormData = new FormData();

    if (data.title) bodyFormData.set("title", data.title);
    if (data.title_ar) bodyFormData.set("title_ar", data.title_ar);
    if (data.placeholder) bodyFormData.set("placeholder", data.placeholder);
    if (data.placeholder_ar)
      bodyFormData.set("placeholder_ar", data.placeholder_ar);
    if (data.item_ids)
      bodyFormData.set("item_ids", JSON.stringify(data.item_ids));
    if (data.gift_ids)
      bodyFormData.set("gift_ids", JSON.stringify(data.gift_ids));
    if (data.required_quantity)
      bodyFormData.set("required_quantity", data.required_quantity);
    if (data.offer_type) bodyFormData.set("offer_type", data.offer_type);
    if (data.brand_path) bodyFormData.set("brand_path", data.brand_path);
    if (data.category_path)
      bodyFormData.set("category_path", data.category_path);
    if (data.offer_percentage !== null)
      bodyFormData.set("offer_percentage", data.offer_percentage);
    if (data.compensation_percentage !== null)
      bodyFormData.set("compensation_percentage", data.compensation_percentage);

    if (data.free_category_path)
      bodyFormData.set("free_category_path", data.free_category_path);
    if (data.free_brand_path)
      bodyFormData.set("free_brand_path", data.free_brand_path);
    if (data.free_item_ids)
      bodyFormData.set("free_item_ids", JSON.stringify(data.free_item_ids));

    bodyFormData.set("is_active", data.is_active ? true : false);

    if (data.image) bodyFormData.append("image", data.image);
    if (data.image_ar) bodyFormData.append("image_ar", data.image_ar);

    if (data._id) {
      url = `offers/` + data._id;
      try {
        const promotion = await axiosInstance.put(url, bodyFormData);
        return promotion.data;
      } catch (error) {
        throw error;
      }
    } else {
      try {
        const promotion = await axiosInstance.post(url, bodyFormData);
        return promotion.data;
      } catch (error) {
        throw error;
      }
    }
  },
};

export default actions;
